import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

// Note: TextField is also a base for TextArea
export const TextField = theme(Headless.TextField, [
  css({
    // Shadows get clipped on ios safari without appearance: none
    appearance: css.value('none'),
    backgroundColor: 'surface',
    border: css.value('none'),
    borderRadius: 'xsmall',
    keyline: 'neutral',
    color: 'primary',
    font: 'body',
    fontFamily: 'ui',
    layout: 'inline-row',
    transition: css.value('box-shadow 240ms'),
    width: 'fill',
    boxSizing: css.value('border-box'),

    // https://css-tricks.com/snippets/css/turn-off-number-input-spinners/
    '&[type=number]': {
      MozAppearance: css.value('textfield'),
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: css.value('none'),
        margin: 0,
      },
    },

    '&::placeholder': {
      color: 'disabled',
    },

    '&:disabled': {
      backgroundColor: css.value('$color.neutral50'),
      color: 'disabled',
    },

    '&:focus': {
      outline: css.value('none'),
    },

    [Headless.TextFieldVariants.size.small]: {
      paddingX: 'small',
      paddingY: 'xsmall',
      fontSize: css.value('12px'),
      lineHeight: css.value('16px'),
    },

    [Headless.TextFieldVariants.size.medium]: {
      paddingX: 'small',
      paddingY: 'xsmall',
    },

    [Headless.TextFieldVariants.size.large]: {
      paddingX: css.value('12px'),
      paddingY: 'small',
      fontSize: css.value('16px'),
      lineHeight: css.value('24px'),
    },

    [Headless.TextFieldVariants.invalid.true]: {
      keyline: 'critical',
    },

    [Headless.TextFieldVariants.isInCompositeField.true]: {
      boxShadow: 'none',
      padding: 0,
    },
  }),
]);

export const TextArea = theme(Headless.TextArea, [
  css({
    [Headless.TextAreaVariants.resizeable.true]: {
      resize: css.value('vertical'),
    },

    [Headless.TextAreaVariants.resizeable.false]: {
      resize: css.value('none'),
    },

    [Headless.TextAreaVariants.size.small]: {
      minHeight: css.value('24px'),
    },

    [Headless.TextAreaVariants.size.medium]: {
      minHeight: css.value('28px'),
    },

    [Headless.TextAreaVariants.size.large]: {
      minHeight: css.value('36px'),
    },
  }),
]);

export const TextFieldLabel = theme(Headless.TextFieldLabel, [
  css({
    font: 'body',
    // TODO: this is the correct value for the font-weight here,
    // but it's not available as a font-weight
    fontWeight: css.value(500),

    [Headless.TextFieldLabelVariants.position.top]: {
      // TODO: maybe use flexbox and a gap here instead
      display: css.value('block'),
      marginBottom: 'xsmall',
    },
  }),
]);
